import { Spacing } from "types/Spacing";

export const COLUMN_ORDER = "minmax(120px, 1fr) minmax(90px, 1fr)  minmax(90px, 4fr)";
export const COLUMN_GAP: Spacing = "large";
export const PERSONAL_SETTINGS_ADMIN_INFO_KEY = "personalSettingsAdminInfo";
